import { render, staticRenderFns } from "./ItemFormMsds.vue?vue&type=template&id=7db90028&scoped=true&"
import script from "./ItemFormMsds.vue?vue&type=script&lang=js&"
export * from "./ItemFormMsds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db90028",
  null
  
)

export default component.exports